<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default>
      <div class="main tw-overflow-x-hidden">
        <BrandPattern4 ref="animation" page="APPBARLAYOUT" />
        <backgroundComponent ref="backgroundRef" />
        <ActivePathWrapper
          :active-hierarchy="[
            getComponentUiText('app-menu-assess-1'),
            getComponentUiText('app-menu-submenu-assess-manage-assessments-1'),
          ]"
        />
        <div
          :style="`
            width: 100%;
            position: relative;
            z-index: 0;
            
            `"
          :class="`tw-bg-[#fff] xl:tw-px-[60px] tw-px-[10px] xl:tw-py-[55px] tw-py-[30px]`"
        >
          <div
            style="line-height: 22px"
            class="title tw-text-2xl tw-font-semibold tw-text-[#211F58] tw-text-[22px]"
          >
            {{ getComponentUiText("app-manage-assessment-title-1") }}
          </div>
        </div>
        <div
          :class="`content-wrapper ${isMenuPin ? 'content-wrapper-pin' : ''}`"
        >
          <div
            id="click-box-assessment"
            :class="`2xl:tw-w-[1040px] tw-gap-0 content assessment-container ${
              isMenuPin ? 'assessment-container-pin content-pin' : ''
            }`"
          >
            <div class="assessment-content">
              <!-- title and bulk action -->
              <div
                class="title-container tw-flex tw-items-center tw-justify-between"
              >
                <p class="tw-my-0">
                  <span class="title tw-mr-[10px]">{{
                    getComponentUiText("app-assessment-title-1")
                  }}</span>
                </p>
                <div class="group-button tw-flex tw-items-center">
                  <ButtonBulkActions
                    :id-popover="'popover-btn-bulk-action-assessment'"
                    :active="isActiveBulkActions"
                    :selected-number="assessmentSelectedCount"
                  />
                  <ButtonFilter
                    :active="false"
                    :id-popover="'popover-btn-filter-assessment'"
                    button-class="tw-mr-5"
                  />
                  <IconButton
                    src="/img/plus_icon.svg"
                    @click="openCreateAssessmentModal"
                  />
                </div>
              </div>
              <!-- Information -->
              <div
                class="tw-flex tw-flex-col tw-gap-[25px] tw-mt-[20px] tw-w-full tw-rounded-[6px]"
              >
                <div
                  v-if="
                    isChecklistDetailDataLoading &&
                    checklistDetailData?.length === 0
                  "
                  class="custom-global-skeleton tw-w-full tw-h-[72px] tw-rounded-[6px]"
                ></div>
                <AssessmentDetails
                  v-for="(item, index) in checklistDetailData"
                  :key="`${item.checklistDateEdited}${item.checklistId}`"
                  :index="index"
                  :id-popover="`popover-assessment-details-${index}`"
                  :id-popover-show-duplicate-assessment="`popover-btn-show-duplicate-assessment-detail-setting-${index}`"
                  :details="addCurrentItemToChild(item)"
                  :checklist-id="item.checklistId"
                  :show-details="index === 0"
                  @select:assessment="handleSelectAssessment"
                  @loaded="
                    () => {
                      isChecklistDetailDataLoading = false;
                      pageLoaded();
                    }
                  "
                  @on-refresh="handleRefresh"
                />
                <AssessmentCreateButton
                  :title="
                    checklistDetailData?.length
                      ? getComponentUiText(
                          'app-assessment-button-create-button-1',
                        )
                      : getComponentUiText(
                          'app-assessment-button-create-button-2',
                        )
                  "
                  @click="openCreateAssessmentModal"
                />
              </div>
            </div>

            <!-- Actions buttons -->
            <div
              class="tw-relative tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content] actionsWrapper tw-max-w-[241px] lg:tw-min-w-[241px]"
            >
              <ActionButton :profile-actions="profileActions" />
            </div>
          </div>
        </div>
      </div>
      <CreateAssessmentModal
        v-model:show="createAssessmentShow"
        :assessments-history="assessmentsHistory"
        @reset-modal-history="resetModalHistory"
        @open-manage-template-modal="
          () => {
            createAssessmentShow = false;
            showModalManageTemplate = true;
          }
        "
      />
      <ManageTemplateModal v-model:show="showModalManageTemplate" />
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import {
  Ref,
  computed,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import { addCurrentItemToChild, getComponentUiText } from "@/utils/utilities";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import AssessmentCreateButton from "@/components/assessment/assessmentCreateButton.vue";
import CreateAssessmentModal from "@/components/assessment/createAssessmentModal.vue";
import { processChecklistAssessmentDataNewVerson } from "@/services/assessment";
import { Assessment } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import PlusWrappedIcon from "@/components/svgs/plusWrappedIcon.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import AssessmentDetails from "@/components/assessment/assessmentDetails.vue";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import get from "lodash/get";
import store from "@/store";
import { localStorageKey } from "@/utils/constants";
import { useRoute } from "vue-router";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import router from "@/router";
import ManageTemplateModal from "@/components/assessment/manageTemplateModal.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import cloneDeep from "lodash/cloneDeep";

const profileActions: Action[] = [
  {
    icon: PlusWrappedIcon,
    iconColor: "#211F58",
    title: "app-assessment-view-exposures-1",
    titleClass: "tw-max-w-[175px]",
    onClick: () => {
      router.push({ path: "/assess/roadmap" });
    },
  },
  {
    id: "ma-btn-manage-teamplates",
    icon: UserIcon,
    title: "app-assessment-assessment-settings-manage-templates-1",
    titleClass: "tw-max-w-[175px]",
    onClick: () => {
      showModalManageTemplate.value = true;
    },
  },
];

let isActiveBulkActions: Ref<boolean> = ref(false);
const route = useRoute();
const backgroundRef = ref(null);
const listAssessmentSelected: string[] = [];
const assessmentSelectedCount = ref(0);
const assessmentsHistory = ref<
  {
    name: string;
    state: string;
    date: string;
    isLarge: boolean;
    history: any[];
  }[]
>([]);
// const checklistDetailData: Ref<IAssessmentDetail[]> = ref([]);
const createAssessmentShow = ref(false);
const showModalManageTemplate = ref(false);
const isChecklistDetailDataLoading: Ref<boolean> = ref(false);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const currentOrg = computed(() => store.state.Org.currentOrg);
const isMenuPin = computed(
  () =>
    store.state.Navigation.chevronActive && store.state.Navigation.isMenuOpen,
);

watch(
  () => currentOrg.value.orgId,
  (newVal, oldVal) => {
    if (newVal !== oldVal && newVal && oldVal) {
      getTemplate();
      getChecklistAssessment();
    }
  },
);

const pageLoaded = () => {
  setTimeout(() => {
    if (isLoading.value) {
      EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
    }
  }, 500);
};

onMounted(async () => {
  try {
    await getTemplate();
    await initial();
    await getChecklistAssessment();
    const param = route?.query?.param;
    if (param) {
      openCreateAssessmentModal();
    }
  } catch (error) {
    showErrorAPI(error, Assessment.getChecklists);
  }
});

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});

const handleRefresh = async () => {
  await getTemplate();
  await initial();
  await getChecklistAssessment();
};

const initial = async () => {
  const userData = JSON.parse(
    localStorage.getItem(localStorageKey.currentUserData) || "{}",
  );
  store.dispatch("User/getUserProfile", userData.userId);
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("click-box-assessment")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });
};

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
});

const checklistDetailData = computed(() => {
  return processChecklistData(
    cloneDeep(store.state.Assessment.checklistAssessment),
  );
});

const getChecklistAssessment = async () => {
  try {
    isChecklistDetailDataLoading.value = true;
    const res = await store.dispatch("Assessment/fetchChecklistAssessment");
    const checklist: IAssessmentDetail[] = get(res, "data.data", []);
    // checklistDetailData.value = processChecklistData(checklist);

    await store.dispatch("Assessment/fetchChecklistAssessmentDetail");
    await store.dispatch("Assessment/getAllScoreDetail");
    if (isLoading.value) {
      EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
    }
  } catch (error) {
    showErrorAPI(error, Assessment.getChecklists);
  } finally {
    isChecklistDetailDataLoading.value = false;
  }
};

const openCreateAssessmentModal = async () => {
  createAssessmentShow.value = true;
  await localStorage.removeItem(localStorageKey.assessmentView);
  await localStorage.removeItem(localStorageKey.isHideComplete);
  await localStorage.removeItem(localStorageKey.showMasterItems);
  store.commit("Assessment/INITIALISE");
};

const processChecklistData = (data: IAssessmentDetail[]) => {
  let result: IAssessmentDetail[] = [];
  if (!data || data.length === 0) {
    assessmentsHistory.value = [];
    return result;
  }

  const checklistTreeWithoutArchivedSort =
    processChecklistAssessmentDataNewVerson(data);
  assessmentsHistory.value = checklistTreeWithoutArchivedSort.map((e) => {
    return {
      name: e.checklistName,
      state: e.checklistStatus,
      date: getTime(e.checklistDateCreated),
      isLarge: false,
      id: e.checklistId,
      history: e.checklistAssessmentHistory,
      checklistInforDetail: {
        checklistId: e.checklistId,
        checklistStatus: e.checklistStatus,
        checklistStatusId: e.checklistStatusId,
      },
    };
  });
  return checklistTreeWithoutArchivedSort;
};

const resetModalHistory = () => {
  assessmentsHistory.value.forEach((e: any) => {
    e.isLarge = false;
    e.history.forEach((el) => {
      el.isActive = false;
    });
  });
};

const handleSelectAssessment = ($event) => {
  const index = listAssessmentSelected.findIndex((item) => item === $event);

  if (index !== -1) listAssessmentSelected.splice(index, 1);
  else listAssessmentSelected.push($event);

  if (listAssessmentSelected.length >= 1) isActiveBulkActions.value = true;
  else isActiveBulkActions.value = false;
  assessmentSelectedCount.value = listAssessmentSelected.length;
};

const getTemplate = async () => {
  await store.dispatch("Assessment/getTemplate");
};

const getTime = (time: string) => {
  return convertUTCTimeToLocalTime(time);
};
</script>

<style lang="scss" scoped>
#appBarLayout {
  overflow-y: hidden;
}

#body {
  flex-wrap: nowrap;
}

.main {
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
  height: 100%;
  overflow-y: auto;
}

.content-wrapper {
  display: flex;
  padding: 55px 60px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-top: 1px solid var(--UI-rule, #eff0f1);
  position: relative;
}

.assessment-container {
  gap: 60px;
  .title {
    font-size: 18px;
    line-height: 100%;
    color: #211f58;
    font-weight: 600;
  }

  .sub-title {
    color: #211f58;
  }
}

.content {
  display: flex;

  .assessment-content {
    min-width: 100%;
  }
}

.invited-table {
  margin-top: 40px;
}

.table-header {
  margin-bottom: 15px;
}

.actions-button-container {
  margin-top: 40px;
  margin-bottom: 40px;
}

.header-user {
  min-width: 500px;
}

@media (max-width: 1198px) {
  .assessment-container {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 0 15px 0 10px;
    max-width: 100%;
    gap: 40px;
  }

  .content {
    flex-direction: column-reverse;
  }

  .actions-button-container {
    margin-left: 0px;
  }
}
@media (max-width: 1280px) {
  .content-wrapper {
    padding: 40px 0px;
  }
}
@media (max-width: 1710px) {
  .assessment-container-pin {
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 0 15px 0 10px !important;
    max-width: 100% !important;
    gap: 40px !important;
  }

  .content-pin {
    flex-direction: column-reverse !important;
  }

  .actions-button-container-pin {
    margin-left: 0px !important;
  }
  .content-wrapper-pin {
    padding: 40px 0px !important;
  }
}
@media (max-width: 1535px) {
  .assessment-container {
    width: 70vw;
  }
}
@media (max-width: 1198px) {
  .assessment-container {
    width: 100%;
  }
}
@media (max-width: 520px) {
  .title-container {
    gap: 10px;
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
